import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    fetchEmployeeProfilePending: false,
    updateEmployeeProfilePending: false,
    profile: {},
    fetchResumePending: false,
    fetchResumeItemPending: false,
    storeResumeItemPending: false,
    deleteResumeItemPending: false,
    fetchApplicationsPending: false,
    storeApplicationPending: false,
    deleteApplicationPending: false,
    fetchCooperationAgreementsPending: false,
    jobApplications: {
      all: [],
      open: [],
      draft: [],
      closed: [],
    },
    resume: {
      jobs: [],
      educations: [],
      languages: [],
      certifications: [],
    },
    cooperationAgreements: [],
    applicationInEdit: {},
  },
  actions,
  mutations,
};
